import "./styles.scss"

const NotFoundScreen = ({ platformName, platformLogo }) => {
  return (
    <div className="not-found-screen">
      <section className="not-found-screen__section">
        <div
          className="not-found-screen__section-logo"
          style={{ backgroundImage: `url(${platformLogo})` }}
        />
      </section>
      <section className="not-found-screen__section">
        <div className="not-found-screen__section-details">
          <h1 className="not-found-screen__section-details-404">404</h1>
          <span className="not-found-screen__section-details-pagenotfounddesc">
            Página não encontrada
          </span>
          <span className="not-found-screen__section-details-pagenotfounddesc-platform">
            O endereço que procura não existe na {platformName}.
          </span>
        </div>
      </section>
    </div>
  )
}

export default NotFoundScreen
